<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Energy Consumption</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="energyData"
    dataKey="Id"
    editMode="row"
    id="EnergyConsumptionTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="font-weight: bold; width: 100px">Months</th>
        <th class="center-table" style="width: 200px">
          Total Gas Production (m3)
        </th>
        <th class="center-table" style="width: 200px">
          Fuel Gas - Generators (m3)
        </th>
        <th class="center-table" style="width: 200px">
          Fuel Gas - Heater Treater (m3)
        </th>
        <th class="center-table" style="width: 200px">
          All Gas Flared (m3)
        </th>
        <th class="center-table" style="width: 200px">
          Total Produced Water (m3)
        </th>
        <th class="center-table" style="width: 200px">PW Re-Injected (m3)</th>
        <th class="center-table" style="width: 200px">PW Evaporated (m3)</th>
        <th class="center-table" style="width: 200px">
          Water Abstracted for Water Injection (BBLS)
        </th>
        <th class="center-table" style="width: 200px">EPF DGS (L)</th>
        <th class="center-table" style="width: 200px">Camp DGS (L)</th>
        <th class="center-table" style="width: 200px">
          Contractor DGS (L)
        </th>
        <th class="center-table" style="width: 200px">Vehicle (L)</th>
        <th class="center-table" style="width: 200px">Stationary Sources (L)</th>
        <th class="center-table" style="width: 200px">Generators (L)</th>
        <th class="center-table" style="width: 200px">Other (L)</th>
        <th class="center-table" style="width: 100px">Wells (L)</th>
        <th class="center-table" style="width: 9rem">Consumption (M3)</th>
        <th class="center-table" style="width: 200px">Mains Electricity - EPF</th>
        <th class="center-table" style="width: 200px">Mains Electricity - Camp</th>
        <th class="center-table" style="width: 200px">Mains Electricity - Wells</th>
        <th class="center-table">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-energy
      let-editing="editing"
      let-ri="rowIndex"
    >
      <tr [pEditableRow]="energy">
        <td
          style="width: 100px"
          [ngStyle]="{
            'font-weight': energy.category === 'Total' ? 'bold' : 'normal'
          }"
        >
          {{ energy.category }}
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.NaturalGasProd"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 1)
                "
                data-target="#AT"
              >
                {{ energy.NaturalGasProd }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.FuelGasGenerators"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 15)
                "
                data-target="#AT"
              >
                {{ energy.FuelGasGenerators }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.FuelGasTreater"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 2)
                "
                data-target="#AT"
              >
                {{ energy.FuelGasTreater }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.AllGasFlared"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 3)
                "
                data-target="#AT"
              >
                {{ energy.AllGasFlared }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.TotalProducedWater"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 4)
                "
                data-target="#AT"
              >
                {{ energy.TotalProducedWater }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.PWReInjected"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 5)
                "
                data-target="#AT"
              >
                {{ energy.PWReInjected }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.PWEvaporated"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 6)
                "
                data-target="#AT"
              >
                {{ energy.PWEvaporated }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.WaterAbstracted"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 7)
                "
                data-target="#AT"
              >
                {{ energy.WaterAbstracted }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.EPFDGS"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 8)
                "
                data-target="#AT"
              >
                {{ energy.EPFDGS }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.CampDGS"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 9)
                "
                data-target="#AT"
              >
                {{ energy.CampDGS }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.ContractorDGS"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 10)
                "
                data-target="#AT"
              >
                {{ energy.ContractorDGS }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.Vehicle"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 11)
                "
                data-target="#AT"
              >
                {{ energy.Vehicle }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.StationarySource"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 16)
                "
                data-target="#AT"
              >
                {{ energy.StationarySource }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.Generators"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 17)
                "
                data-target="#AT"
              >
                {{ energy.Generators }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.Other"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 12)
                "
                data-target="#AT"
              >
                {{ energy.Other }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.WellsDGS"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 13)
                "
                data-target="#AT"
              >
                {{ energy.WellsDGS }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.WaterConsumption"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 14)
                "
                data-target="#AT"
              >
                {{ energy.WaterConsumption }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.MainsElectricityEPF"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 18)
                "
                data-target="#AT"
              >
                {{ energy.MainsElectricityEPF }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.MainsElectricityCamp"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 19)
                "
                data-target="#AT"
              >
                {{ energy.MainsElectricityCamp }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="energy.MainsElectricityWells"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetEnergyConsumptionSelectedDetails(0, energy.category, 20)
                "
                data-target="#AT"
              >
                {{ energy.MainsElectricityWells }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(energy)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(energy, ri)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(energy, ri)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container
            *ngFor="let item of EnergyConsumptionData; let i = index"
          >
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="EnergyConsumptionData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
